import {UserModel} from 'app/models/UserModel'
import {NotFound} from 'app/modules/errors/NotFound'
import SchoolToInstitute from 'app/pages/school/school/SchoolToInstitute'
import {Settings} from 'app/pages/settings/Settings'
import {PortalAccessOutlet} from 'app/pages/student/Fee/AccessGuard/PortalAccessGuard'
import {hasPermission, isLyceum, isM_Layout, isParent} from 'common/HelperFunctions'
import {isDevEnv} from 'common/HelperFunctions'
import LegacyRedirect from 'common/components/LegacyRedirect'
import SuspensedView from 'common/components/SuspensedView'
import {isNewFeePageEnabled} from 'common/helpers/fee'
import {lazyWithRetry} from 'common/helpers/lazyWithRetry'
import {useIsNewExamManagerEnabled} from 'common/hooks/useIsNewExamManagerEnabled'
import IframeLayout from 'common/layout/IframeLayout'
import {usePostHog} from 'posthog-js/react'
import {FC, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {Navigate, Route, Routes} from 'react-router'
import {RootState} from 'setup'
import {identifyClarityUser} from 'telemetry/clarity'

import {MasterLayout} from '_metronic/layout/MasterLayout'

/*
 * CCCCC
 * C
 * C
 * C
 * CCCCC
 */
const ChatPage = lazyWithRetry(() => import('common/components/chat/ChatPage'))

/*
 * DDDDD
 * D    D
 * D     D
 * D    D
 * DDDDD
 */
const Dashboard = lazyWithRetry(() => import('app/pages/student/dashboard/Dashboard'))
// Same module the school side uses; the API scopes the list to the student /
// selected child and the update/delete actions are permission-gated.
const DigitalRequestPage = lazyWithRetry(
  () => import('app/pages/school/digital-request/DigitalRequestPage')
)

/*
 * EEEEEE
 * E
 * EEEE
 * E
 * EEEEEE
 */

const EventPageHighlights = lazyWithRetry(
  () => import('app/pages/school/Event/components/Highlights')
)
const EventPageView = lazyWithRetry(() => import('app/pages/school/Event/components/View'))
const EventPageGallery = lazyWithRetry(() => import('app/pages/school/Event/components/Gallery'))

const ExamSchedulePage = lazyWithRetry(
  () => import('app/pages/school/ExamSchedule/ExamSchedulePage')
)
/*
 * FFFFFF
 * F
 * FFFF
 * F
 * F
 */

/*
 * L
 * L
 * L
 * L
 * LLLLL
 */
const LGSFeeIframe = lazyWithRetry(() => import('app/pages/student/LGSFeeIframe'))

/*
 * FFFFFF
 * F
 * FFFF
 * F
 * F
 */
const StudentFeePage = lazyWithRetry(() => import('app/pages/student/Fee/FeePage'))

/*
 * N    N
 * NN   N
 * N N  N
 * N  N N
 * N   NN
 */
const StudentNotificationsPage = lazyWithRetry(
  () => import('app/pages/student/Notifications/NotificationsPage')
)

// Native replacements for the remaining simple student/parent iframe pages
const StudentActivitiesPage = lazyWithRetry(
  () => import('app/pages/student/Activities/ActivitiesPage')
)
const StudentClassHistoryPage = lazyWithRetry(
  () => import('app/pages/student/ClassHistory/ClassHistoryPage')
)
const StudentTutorialsPage = lazyWithRetry(
  () => import('app/pages/student/Tutorials/TutorialsPage')
)
const StudentExamsListPage = lazyWithRetry(() => import('app/pages/student/Exam/StudentExamsPage'))
const StudentExamViewPage = lazyWithRetry(
  () => import('app/pages/student/Exam/StudentExamViewPage')
)
const StudentSubjectsPage = lazyWithRetry(
  () => import('app/pages/student/Subject/StudentSubjectsPage')
)
const StudentSubjectAreaRoutes = lazyWithRetry(
  () => import('app/pages/student/Subject/SubjectRoutes')
)
const StudentReportCardPage = lazyWithRetry(
  () => import('app/pages/student/StudentReports/StudentReportCardPage')
)
const StudentOldReportCardPage = lazyWithRetry(
  () => import('app/pages/student/OldReportCard/OldReportCardPage')
)
const StudentDatesheetPage = lazyWithRetry(
  () => import('app/pages/student/StudentReports/StudentDatesheetPage')
)
const StudentPerformanceReportPage = lazyWithRetry(
  () => import('app/pages/student/StudentReports/StudentPerformanceReportPage')
)
const StudentLiveStreamPage = lazyWithRetry(
  () => import('app/pages/student/StudentReports/LiveStreamPage')
)
const ParentingPage = lazyWithRetry(() => import('app/pages/parenting/ParentingPage'))
const StudentHomeworkRoutes = lazyWithRetry(
  () => import('app/pages/student/Homework/HomeworkRoutes')
)
const StudentTestListPage = lazyWithRetry(() => import('app/pages/student/Test/TestListPage'))
const StudentTestViewPage = lazyWithRetry(() => import('app/pages/student/Test/TestViewPage'))
const StudentQuizInstructionsPage = lazyWithRetry(
  () => import('app/pages/student/Quiz/QuizInstructionsPage')
)
const StudentQuizTakePage = lazyWithRetry(() => import('app/pages/student/Quiz/QuizTakePage'))
const StudentQuizResultPage = lazyWithRetry(() => import('app/pages/student/Quiz/QuizResultPage'))
const StudentLectureListPage = lazyWithRetry(
  () => import('app/pages/student/Lecture/LectureListPage')
)
const StudentLectureViewPage = lazyWithRetry(
  () => import('app/pages/student/Lecture/LectureViewPage')
)
const StudentAttendanceReportPage = lazyWithRetry(
  () => import('app/pages/student/Attendance/StudentAttendanceReportPage')
)
const StudentSubjectAttendanceReportPage = lazyWithRetry(
  () => import('app/pages/student/Attendance/StudentSubjectAttendanceReportPage')
)
const StudentActivityAttendanceReportPage = lazyWithRetry(
  () => import('app/pages/student/Activities/StudentActivityAttendanceReportPage')
)
const StudentSubjectAmendmentRequestPage = lazyWithRetry(
  () => import('app/pages/student/Attendance/amendment/SubjectAmendmentRequestPage')
)
const StudentCampusAmendmentRequestPage = lazyWithRetry(
  () => import('app/pages/student/Attendance/amendment/CampusAmendmentRequestPage')
)
const StudentAmendmentRequestsPage = lazyWithRetry(
  () => import('app/pages/student/Attendance/amendment/AmendmentRequestsPage')
)

/*
 * N    N
 * NN   N
 * N N  N
 * N  N N
 * N   NN
 * N    N
 */

const NewsPageFullmode = lazyWithRetry(() => import('app/pages/school/News/components/FullMode'))
const NewsPageView = lazyWithRetry(() => import('app/pages/school/News/components/View'))

/*
 * PPPPPPP
 * P    P
 * PPPPPP
 * P
 * P
 */
const ProfilePage = lazyWithRetry(() => import('app/pages/common/profile/ProfilePage'))
const PerformanceReportsPage = lazyWithRetry(
  () => import('app/pages/school/PerformanceReports/PerformanceReportsPage')
)

/*
 *  SSSSS
 * S
 *  SSSSS
 *       S
 * SSSSS
 */
const SchoolPage = lazyWithRetry(() => import('app/pages/school/school/SchoolPage'))
const CollegeCounsellingPage = lazyWithRetry(
  () => import('app/pages/school/CollegeCounselling/CollegeCounsellingPage')
)
const StudentExamsPage = lazyWithRetry(
  () => import('app/pages/student/StudentExams/StudentExamsPage')
)
const StudentProfilePage = lazyWithRetry(
  () => import('app/pages/student/StudentProfile/StudentProfilePage')
)
const SchoolBlogPage = lazyWithRetry(() => import('app/pages/student/SchoolBlog/SchoolBlogPage'))
const FamilyNotificationPages = lazyWithRetry(
  () => import('app/pages/student/NotificationPages/NotificationPages')
)
const ProUpgradePage = lazyWithRetry(() => import('app/pages/student/ProUpgrade/ProUpgradePage'))
const HelpRoutes = lazyWithRetry(() => import('app/pages/student/Help/HelpRoutes'))
const UserManualEntry = lazyWithRetry(() => import('app/pages/userManual/UserManualEntry'))
const SchedulePageYearly = lazyWithRetry(
  () => import('app/pages/school/Schedule/components/yearly/YearlyCalendar')
)
const SchedulePageDaily = lazyWithRetry(
  () => import('app/pages/school/Schedule/components/daily/DailySchedule')
)
const SchedulePageHighlights = lazyWithRetry(
  () => import('app/pages/school/Schedule/components/yearly/Highlights')
)
const SchedulePageYearlyView = lazyWithRetry(
  () => import('app/pages/school/Schedule/components/yearly/ViewYearly')
)
const SchedulePageDailyView = lazyWithRetry(
  () => import('app/pages/school/Schedule/components/daily/ViewDaily')
)
const StudentSubjectCombinedAttendanceReport = lazyWithRetry(
  () =>
    import('app/pages/school/Attendance/components/utils/StudentSubjectCombinedAttendanceReport')
)

/**
 * Legacy family URL → native route. Only paths whose native page exists for
 * every family user; permission gates still apply on the target route.
 */
const LEGACY_FAMILY_ALIASES: [string, string][] = [
  ['site/dashboard', '/dashboard'],
  ['site/index', '/dashboard'],
  ['news', '/institute/news/fullmode'],
  ['news/index', '/institute/news/fullmode'],
  ['news/fullNews', '/institute/news/fullmode'],
  ['news/view/:id', '/institute/news/:id'],
  ['news/view/id/:id', '/institute/news/:id'],
  ['news/:id', '/institute/news/:id'],
  ['events/admin', '/institute/events/highlights'],
  ['events/gallery/:id', '/institute/events/:id/gallery'],
  ['events/gallery/id/:id', '/institute/events/:id/gallery'],
  ['yearlySchedule/calendar', '/institute/schedule/yearly-calendar'],
  ['yearlySchedule/index', '/institute/schedule/yearly/highlights'],
  ['yearlySchedule/view/:id', '/institute/schedule/:id'],
  ['yearlySchedule/view/id/:id', '/institute/schedule/:id'],
  ['dailySchedule/calendar', '/institute/schedule/daily-calendar'],
  ['dailySchedule/view/:id', '/institute/schedule/daily/:id'],
  ['dailySchedule/view/id/:id', '/institute/schedule/daily/:id'],
  // node schedule notifications (shared with teachers, so kept as is)
  ['schedule/yearly', '/institute/schedule/yearly-calendar'],
  ['schedule/daily', '/institute/schedule/daily-calendar'],
  ['activities/grid', '/activities'],
  ['studentClassHistory/index', '/class-history'],
  ['site/tutorials', '/tutorials'],
  ['site/tutorials/:id', '/tutorials'],
  ['notification/admin', '/notifications'],
  ['yearlySchedule', '/institute/schedule/yearly-calendar'],
  ['dailySchedule', '/institute/schedule/daily-calendar'],
  ['dailySchedule/activityWiseCalendar', '/institute/schedule/daily-calendar'],
  ['events', '/institute/events/highlights'],
  ['events/index', '/institute/events/highlights'],
  ['digitalRequests/absence', '/institute/digital-requests/create'],
  ['digitalRequests/examHomeworkTests', '/institute/digital-requests/create'],
  ['digitalRequests/viewLeaveAbsenceRequests', '/institute/digital-requests/list'],
  ['digitalRequests/leaveRequestMessage', '/institute/digital-requests/list'],
  ['digitalRequests/view/:id', '/institute/digital-requests/:id/update'],
  ['digitalRequests/view/id/:id', '/institute/digital-requests/:id/update'],
  ['digitalRequests/:id', '/institute/digital-requests/:id/update'],
  ['messages/index', '/messages'],
  ['messages/compose', '/messages'],
  ['messages/view/:id', '/messages/:id'],
  ['messages/view/id/:id', '/messages/:id'],
  ['user/profile', '/profile/info'],
  ['user/edit', '/profile/edit'],
  ['user/changepassword', '/profile/change-password'],
  ['user/changesession', '/profile/change-session'],
  ['user/childrenView', '/student/view/info'],
  ['site/defaulteraccessdisable', '/dashboard'],
  ['site/recheckingForm', '/profile/rechecking-form'],
  ['site/viewRecheckingRecord', '/profile/rechecking-form'],
]

const StudentRoutes: FC = () => {
  const posthog = usePostHog()
  const user = useSelector<RootState>((state) => state.userReducer.user) as UserModel
  const userType = useSelector<RootState>((state) => state.userReducer.userType) as string
  const tenant = useSelector<RootState>((state) => state.userReducer.tenant) as string
  // Reactive by construction — see the hook: a prod hard-load renders this
  // route table before general settings arrive.
  const newExamManagerEnabled = useIsNewExamManagerEnabled()

  let Layout = MasterLayout
  if (isM_Layout()) {
    Layout = IframeLayout
  }

  useEffect(() => {
    if (user.id) {
      posthog?.group('tenant', tenant)
      posthog?.identify(`${user.id}`, {
        ...user,
        userType,
        tenant,
      })
      identifyClarityUser(user.id, tenant, userType)
    }
  }, [posthog, tenant, user, userType])

  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Fee-defaulter / restricted-login lock (PHP FrontEndController::init) */}
        <Route element={<PortalAccessOutlet />}>
          {/* Redirect to Dashboard after success login */}
          <Route path='auth/*' element={<Navigate to='/dashboard' />} />

          {/* Pages */}
          <Route
            path='attendance/student-subject/combined-report/'
            element={
              <SuspensedView>
                <StudentSubjectCombinedAttendanceReport />
              </SuspensedView>
            }
          />

          <Route
            path='fee'
            element={
              <SuspensedView>
                <LGSFeeIframe />
              </SuspensedView>
            }
          />

          {/* Digital (leave) requests — the native module, which the PHP app also
            embeds; replaces the legacy /digitalRequests/leaveRequestMessage notice */}
          {hasPermission('digital_request_manager') && (
            <Route
              path='institute/digital-requests/*'
              element={
                <SuspensedView>
                  <DigitalRequestPage />
                </SuspensedView>
              }
            />
          )}

          {hasPermission('activity_manager') && (
            <Route
              path='activities'
              element={
                <SuspensedView>
                  <StudentActivitiesPage />
                </SuspensedView>
              }
            />
          )}
          {hasPermission('student_history') && (
            <Route
              path='class-history'
              element={
                <SuspensedView>
                  <StudentClassHistoryPage />
                </SuspensedView>
              }
            />
          )}
          {hasPermission('knowledge_base') && (
            <Route
              path='tutorials'
              element={
                <SuspensedView>
                  <StudentTutorialsPage />
                </SuspensedView>
              }
            />
          )}
          {/* Lyceum hotfix: the school asked for the student/parent exam list to
            be unreachable even while the exam module is on. Hard-coded to the
            lyceum tenant only. Registered as an explicit redirect (not just
            omitted) so /exams cannot fall through to the legacy iframe
            catch-all below. The sidebar/dashboard links are hidden too. */}
          {isLyceum() ? (
            <Route path='exams' element={<Navigate to='/dashboard' replace />} />
          ) : (
            hasPermission('exam_manager_exams') && (
              <Route
                path='exams'
                element={
                  <SuspensedView>
                    <StudentExamsListPage />
                  </SuspensedView>
                }
              />
            )
          )}
          {/* Native exam detail at the legacy URLs (notifications send
            exam/view/<id>); lyceum keeps exams unreachable */}
          {isLyceum()
            ? ['exam/view/:id', 'exam/view/id/:id', 'exam/view', 'exam/admin'].map((path) => (
                <Route key={path} path={path} element={<Navigate to='/dashboard' replace />} />
              ))
            : hasPermission('exam_manager_exams') && (
                <>
                  {['exam/view/:id', 'exam/view/id/:id', 'exam/view'].map((path) => (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <SuspensedView>
                          <StudentExamViewPage />
                        </SuspensedView>
                      }
                    />
                  ))}
                  <Route path='exam/admin' element={<Navigate to='/exams' replace />} />
                </>
              )}
          {hasPermission('subject_manager') && (
            <Route
              path='subjects'
              element={
                <SuspensedView>
                  <StudentSubjectsPage />
                </SuspensedView>
              }
            />
          )}
          {/* Native subject / outline / classwork / resources pages at the legacy URLs */}
          {hasPermission('subject_manager') &&
            (
              [
                'subject',
                'sallaybusSubjectOutline',
                'subjectOutline',
                'classWork',
                'subjectClasswork',
              ] as const
            ).map((area) => (
              <Route
                key={area}
                path={`${area}/*`}
                element={
                  <SuspensedView>
                    <StudentSubjectAreaRoutes area={area} />
                  </SuspensedView>
                }
              />
            ))}

          {/* Native parenting section (legacy /parenting/* URLs) */}
          {isParent() && hasPermission('parenting_section') && (
            <Route
              path='parenting/*'
              element={
                <SuspensedView>
                  <ParentingPage />
                </SuspensedView>
              }
            />
          )}

          {/* Native homework (legacy /homework/admin, /view/:id, /view/id/:id,
            /:id, /addFiles/:id) */}
          {hasPermission('homework_manager') && (
            <Route
              path='homework/*'
              element={
                <SuspensedView>
                  <StudentHomeworkRoutes />
                </SuspensedView>
              }
            />
          )}
          {/* Native tests and online quizzes (instructions, take, result) */}
          {hasPermission('test_manager') && hasPermission('quiz_system') && (
            <>
              {['test/takequiz/:id', 'test/takequiz/id/:id'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentQuizInstructionsPage />
                    </SuspensedView>
                  }
                />
              ))}
              {[
                'test/startquiz/:id',
                'test/startquiz/id/:id',
                'test/startAnswerQuiz/:id',
                'test/startAnswerQuiz/id/:id',
              ].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentQuizTakePage />
                    </SuspensedView>
                  }
                />
              ))}
              {['test/displayquizresult/:id', 'test/displayquizresult/id/:id'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentQuizResultPage />
                    </SuspensedView>
                  }
                />
              ))}
            </>
          )}
          {hasPermission('test_manager') && (
            <>
              <Route
                path='test/admin'
                element={
                  <SuspensedView>
                    <StudentTestListPage />
                  </SuspensedView>
                }
              />
              {['test/view/:id', 'test/view/id/:id', 'test/:id'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentTestViewPage />
                    </SuspensedView>
                  }
                />
              ))}
            </>
          )}

          {/* Native attendance reports at the legacy URLs (the subject report
            redirects to the daily one when subject attendance is off) */}
          {hasPermission('attendance_manager_student_attendance_report') &&
            hasPermission('attendance_manager_view') && (
              <Route
                path='attendance/studentAttendReport'
                element={
                  <SuspensedView>
                    <StudentAttendanceReportPage />
                  </SuspensedView>
                }
              />
            )}
          {hasPermission('attendance_manager_student_subject_attendance_report') &&
            hasPermission('attendance_manager_view') && (
              <Route
                path='attendance/studentSubjectAttendReport'
                element={
                  <SuspensedView>
                    <StudentSubjectAttendanceReportPage />
                  </SuspensedView>
                }
              />
            )}
          {hasPermission('activity_manager') && (
            <Route
              path='activityAttendance/studentActivityAttendReport'
              element={
                <SuspensedView>
                  <StudentActivityAttendanceReportPage />
                </SuspensedView>
              }
            />
          )}
          {/* Attendance amendment requests at the legacy URLs */}
          {hasPermission('attendance_manager_student_attendance_report') &&
            hasPermission('attendance_manager_view') && (
              <>
                <Route
                  path='attendance/amendmentRequest'
                  element={
                    <SuspensedView>
                      <StudentSubjectAmendmentRequestPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='attendance/campusAmendmentRequest'
                  element={
                    <SuspensedView>
                      <StudentCampusAmendmentRequestPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='attendance/viewRequests'
                  element={
                    <SuspensedView>
                      <StudentAmendmentRequestsPage />
                    </SuspensedView>
                  }
                />
              </>
            )}

          {/* Old AJAX report card (legacy /exam/report), native */}
          {hasPermission('old_reportcard') && hasPermission('exam_manager_exam_report_cards') && (
            <Route
              path='exam/report'
              element={
                <SuspensedView>
                  <StudentOldReportCardPage />
                </SuspensedView>
              }
            />
          )}

          {/* Native report cards / datesheet / performance reports / live
            stream at the legacy URLs, for every tenant */}
          {hasPermission('exam_manager_exam_report_cards') && (
            <Route
              path='exam/reportcardnew'
              element={
                <SuspensedView>
                  <StudentReportCardPage />
                </SuspensedView>
              }
            />
          )}
          {/* Report-card notification URL (exam/reportCardView/<student result id>) */}
          {hasPermission('exam_manager_exam_report_cards') &&
            ['exam/reportCardView/:id', 'exam/reportCardView/id/:id'].map((path) => (
              <Route
                key={path}
                path={path}
                element={
                  <SuspensedView>
                    <StudentReportCardPage />
                  </SuspensedView>
                }
              />
            ))}
          {hasPermission('exam_manager_exam_schedules') && (
            <Route
              path='exam/datesheet'
              element={
                <SuspensedView>
                  <StudentDatesheetPage />
                </SuspensedView>
              }
            />
          )}
          {hasPermission('performance_report') && (
            <Route
              path='reports/:type'
              element={
                <SuspensedView>
                  <StudentPerformanceReportPage />
                </SuspensedView>
              }
            />
          )}
          {hasPermission('extra_curricular_activities_live_streaming') && (
            <Route
              path='site/stream'
              element={
                <SuspensedView>
                  <StudentLiveStreamPage />
                </SuspensedView>
              }
            />
          )}

          {/* Native notification inbox (replaces the /notification/admin iframe) */}
          {hasPermission('notification_manager') && (
            <Route
              path='notifications'
              element={
                <SuspensedView>
                  <StudentNotificationsPage />
                </SuspensedView>
              }
            />
          )}

          {/* Family notification detail pages: view/:id, warning/:id, birthday */}
          {hasPermission('notification_manager') && (
            <Route
              path='notification/*'
              element={
                <SuspensedView>
                  <FamilyNotificationPages />
                </SuspensedView>
              }
            />
          )}
          {/* School blog (legacy blogs module) */}
          {hasPermission('school_blog') && (
            <>
              <Route path='blogs' element={<Navigate to='/blogs/blogs' replace />} />
              <Route
                path='blogs/blogs/*'
                element={
                  <SuspensedView>
                    <SchoolBlogPage />
                  </SuspensedView>
                }
              />
            </>
          )}
          {/* Legacy "Upgrade to Pro" page: parents only; anyone else goes to
              their profile, as the PHP page redirects them */}
          <Route
            path='user/subscribe'
            element={
              isParent() ? (
                <SuspensedView>
                  <ProUpgradePage />
                </SuspensedView>
              ) : (
                <Navigate to='/profile/info' replace />
              )
            }
          />

          {/* Native fee vouchers page; links to the legacy
            /finance/finance/view page (bookmarks, notifications) land here */}
          {isNewFeePageEnabled() && hasPermission('fee_manager') && (
            <>
              <Route
                path='fee/vouchers'
                element={
                  <SuspensedView>
                    <StudentFeePage />
                  </SuspensedView>
                }
              />
              <Route
                path='finance/finance/view/*'
                element={<Navigate to='/fee/vouchers' replace />}
              />
            </>
          )}

          <Route
            path='dashboard'
            element={
              <SuspensedView>
                <Dashboard />
              </SuspensedView>
            }
          />

          {/* Same gate as the school routes. For a student or guardian
            `message_manager_view` also carries their own module flag and the
            pro check, so all three toggles are folded into this one question. */}
          {hasPermission('message_manager_view') && (
            <Route
              path='messages/*'
              element={
                <SuspensedView>
                  <ChatPage />
                </SuspensedView>
              }
            />
          )}

          <Route
            path='profile/*'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />

          <Route
            path='institute/counselling/*'
            element={
              <SuspensedView>
                <CollegeCounsellingPage />
              </SuspensedView>
            }
          />

          <Route
            path='student/*'
            element={
              <SuspensedView>
                <StudentProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='institute/schedule/yearly-calendar'
            element={
              <SuspensedView>
                <SchedulePageYearly />
              </SuspensedView>
            }
          />
          <Route
            path='institute/schedule/daily-calendar'
            element={
              <SuspensedView>
                <SchedulePageDaily />
              </SuspensedView>
            }
          />
          <Route
            path='institute/schedule/yearly/highlights/'
            element={
              <SuspensedView>
                <SchedulePageHighlights />
              </SuspensedView>
            }
          />
          <Route
            path='institute/schedule/:id'
            element={
              <SuspensedView>
                <SchedulePageYearlyView />
              </SuspensedView>
            }
          />
          <Route
            path='institute/schedule/daily/:id'
            element={
              <SuspensedView>
                <SchedulePageDailyView />
              </SuspensedView>
            }
          />
          <Route
            path='institute/news/fullmode'
            element={
              <SuspensedView>
                <NewsPageFullmode />
              </SuspensedView>
            }
          />
          <Route
            path='institute/news/:id'
            element={
              <SuspensedView>
                <NewsPageView />
              </SuspensedView>
            }
          />

          <Route
            path='institute/events/highlights'
            element={
              <SuspensedView>
                <EventPageHighlights />
              </SuspensedView>
            }
          />

          <Route
            path='institute/events/:id'
            element={
              <SuspensedView>
                <EventPageView />
              </SuspensedView>
            }
          />

          <Route
            path='institute/events/:id/gallery'
            element={
              <SuspensedView>
                <EventPageGallery />
              </SuspensedView>
            }
          />

          {/* Native family lectures (mobile `lecture` APIs); legacy /course/*
            URLs land on the same pages */}
          {hasPermission('video_lecture') && (
            <>
              {['course/lectures', 'institute/lectures-new/list'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentLectureListPage />
                    </SuspensedView>
                  }
                />
              ))}
              {[
                'course/viewLectures',
                'course/viewLectures/:id',
                'course/viewLectures/id/:id',
                'lectures/viewLectures/:id',
                'institute/lectures-new/:id',
              ].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentLectureViewPage />
                    </SuspensedView>
                  }
                />
              ))}
              {['course/viewLecturesNew', 'course/viewLecturesNew/:id'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <SuspensedView>
                      <StudentLectureViewPage topicWise />
                    </SuspensedView>
                  }
                />
              ))}
            </>
          )}

          <Route path='school/*' element={<SchoolToInstitute />} />
          <Route
            path='settings'
            element={
              <SuspensedView>
                <Settings />
              </SuspensedView>
            }
          />

          <Route
            path='user-manual'
            element={
              <SuspensedView>
                <UserManualEntry />
              </SuspensedView>
            }
          />
          <Route
            path='user-manual/:topic'
            element={
              <SuspensedView>
                <UserManualEntry />
              </SuspensedView>
            }
          />

          {/* Native exam surfaces. Registered BEFORE the catch-all so they take
            precedence; anything under institute/exam they do not handle -- the
            parked datesheet, the legacy AJAX report card -- still falls through
            to the iframe below. */}
          {newExamManagerEnabled && hasPermission('exam_manager') && (
            <Route
              path='institute/exam/*'
              element={
                <SuspensedView>
                  <StudentExamsPage />
                </SuspensedView>
              }
            />
          )}

          {/* FAQs and Contact Us, as in the mobile app (open to every family) */}
          <Route
            path='help/*'
            element={
              <SuspensedView>
                <HelpRoutes />
              </SuspensedView>
            }
          />

          {/* Legacy (Yii front-end) URLs still arrive from notifications, SMS,
            emails and old links; send each to its native page instead of the
            iframe catch-all. The query string (date, nid, …) is kept. */}
          {LEGACY_FAMILY_ALIASES.map(([from, to]) => (
            <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
          ))}

          <Route
            path='*'
            element={
              <SuspensedView>
                <SchoolPage />
              </SuspensedView>
            }
          />

          {isDevEnv() && hasPermission('exam_manager_exam_schedules') && (
            <Route
              path='institute/exam-schedule/*'
              element={
                <SuspensedView>
                  <ExamSchedulePage />
                </SuspensedView>
              }
            />
          )}

          {isDevEnv() && hasPermission('performance_report') && (
            <Route
              path='institute/performance-reports/*'
              element={
                <SuspensedView>
                  <PerformanceReportsPage />
                </SuspensedView>
              }
            />
          )}

          {/* Page Not Found */}
          <Route path='*' element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default StudentRoutes
